import React from 'react';
import clsx from 'clsx';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import Time from '@/components/Clock/Time';

const useStyles = makeStyles(() => ({
  bold:{
    fontWeight: 'bold',
  },
  center: {
    textAlign: 'center',
  },
}));

function shouldShowTime(period){
  if(period.isFinal){
    return false;
  }

  if(period.isShootout){
    return false;
  }

  return true;
}

function Clock({ elapsed, total, period }) {
  const classes = useStyles();
  const isMobile = useMediaQuery(theme => theme.breakpoints.down('sm'));
  const nameSize = isMobile ?  'body1' : 'h4';
  const showTime = shouldShowTime(period);

  return (
    <Grid container className={classes.center}>
      { showTime && (
        <Grid item xs={12}>
          <Time elapsed={elapsed} total={total} />
        </Grid>
      )}
      <Grid item xs={12}>
        <Typography
          className={clsx({[classes.bold]: !showTime})}
          variant={!showTime ? nameSize : 'body2'}
        >
         {period.name}
        </Typography>
      </Grid>
  </Grid>
  )
}

export default Clock;
